"use strict";
/**
 * Created on 06 04 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ObjectUtils_1 = require("../../core/utils/ObjectUtils");
/**
 * <p>Tuple of price list id and product.. You can use it for both internal and external ids according to context of usage.</p>
 *
 * @author JMe
 */


var PriceListProductTuple =
/*#__PURE__*/
function () {
  function PriceListProductTuple(priceListId, productId) {
    _classCallCheck(this, PriceListProductTuple);

    this.priceListId = priceListId;
    this.productId = productId;
  }

  _createClass(PriceListProductTuple, [{
    key: "equals",
    value: function equals(other) {
      if (other instanceof PriceListProductTuple) {
        var otherKey = other;
        return this.priceListId === otherKey.priceListId && this.productId === otherKey.productId;
      } else {
        return false;
      }
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode("".concat(this.priceListId, " - ").concat(this.productId));
    }
  }]);

  return PriceListProductTuple;
}();

exports.PriceListProductTuple = PriceListProductTuple;